

const DEBUG = false;

const DEBUG_SMALL_RESULT_SIZES = false;


export default DEBUG;
export { DEBUG_SMALL_RESULT_SIZES };